import { CLASS_CATEGORY_NAME_MAX_LENGTH } from '@/features/class/manage/constants';

export function validateClassCategoryName(name: string): string | undefined {
  const trimmed = name.trim();
  if (!trimmed) {
    return 'Enter a category name.';
  }
  if (trimmed.length > CLASS_CATEGORY_NAME_MAX_LENGTH) {
    return `Category name must be ${CLASS_CATEGORY_NAME_MAX_LENGTH} characters or fewer.`;
  }
  return undefined;
}
